<template>
  <div class="uploadal">
    <h2>Upload new class work</h2>
    <form @submit.prevent="handleSubmit">
        <label for="assignmentUpload">Select File</label>
        <input
        required
        class="def-cho"
        type="file"
        id="assignmentUpload"
        v-on:change="fileSelected"
        >
        <button :disabled="toggleModal">Upload</button>
        <div class="upload-info">
          <span v-if="uploadFile" class="file-info">File: {{uploadFile.name}}</span>
          <span v-if="uploadFile" class="file-info">Size: {{Math.round((((uploadFile.size/1000)+Number.EPSILON)*100)/100)}}Kb</span>
          <span v-if="uploadProgress" class="file-info-status">{{uploadProgress}}</span>
          <span v-if="uploadError" class="file-info-error">{{uploadError}}</span>
          <span v-if="uploadFile"><span v-if="uploadFile.size >= 5000000" class="file-info-error">File too Large</span></span>
        </div>
    </form>
    <div class="announcements" v-if="uploadError">
        {{ uploadError }}
        <Spinner />
    </div>
    <teleport to="#modals">
      <modal v-if="toggleModal" :text="uploadProgress">Uploading...</modal>
    </teleport>
  </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import Spinner from '@/components/Spinner.vue'
import useUpload from '@/composables/useUpload'
import Modal from './Modal'
import { watchEffect } from '@vue/runtime-core'

export default {
  name: 'FileUpload',
  props: ['uploader'],
  components: { Spinner, Modal },
  setup (props, context) {
    const uploadFile = ref(null)
    const uploadFileSelected = ref(false)
    const uploadError = ref(null)
    const uploadProgress = ref(null)
    const isFileSelected = ref(true)
    const toggleModal = ref(false)

    const { uploadStatus, err, upload } = useUpload()

    const fileSelected = (e) => {
      uploadFileSelected.value = true
      uploadFile.value = e.target.files[0]
    }

    watchEffect(() => {
      uploadProgress.value =
        uploadStatus.value ? uploadStatus.value : null
      uploadError.value =
        err.value ? err.value : null
      isFileSelected.value = uploadFileSelected.value ? uploadFileSelected.value : null
    })

    const handleSubmit = async () => {
      toggleModal.value = true
      // Upload the file and metadata
      await upload(props.uploader, uploadFile.value.name, uploadFile.value)
      if (!err.value) {
        setTimeout(() => {
          toggleModal.value = false
          context.emit('fileuploaded')
        }, 8000)
      } else {
        console.log(err)
      }
    }

    return { uploadFile, handleSubmit, fileSelected, uploadProgress, uploadError, isFileSelected, toggleModal }
  }
}
</script>

<style>
  .uploadal {
    max-width: 960px;
    margin: 0 auto;
  }
  .uploadal label {
    background: rgb(125, 30, 125);
    padding: 8px 12px;
    width: 200px;
    border-radius: 20px;
    height: 30px;
    color: white;
    margin: 0 auto;
  }
  .uploadal .def-cho {
    display: none;
  }
  .uploadal .upload-info {
    display: block;
    color: black;
    background: white;
  }
  .file-info {
    color: black;
    display: block;
  }
  .file-info-status {
    color: rosybrown;
    display: none;
  }
  .file-info-error {
    color: red;
    display: block;
  }
</style>
